export const SERVER_URL =
  process.env.REACT_APP_SERVER_URL || "http://localhost:8070";
export const SERVER_URL_WEBSOCKET =
  process.env.REACT_APP_SERVER_URL_WEBSOCKET || "ws://localhost:8070";
export const FRONTEND_URL =
  process.env.REACT_APP_FRONTEND_URL || "http://localhost:3000";
